export default __webpack_public_path__ + "14c8813382b6f1b70e7b759c25948769.png";